import { Button, Modal } from '@comptia-sso/core';
import { ReactElement } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import styles from './UpgradeSuccessModal.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const UpgradeSuccessModal = ({
  isOpen,
  onClose,
}: Props): ReactElement => {
  const { t } = useTranslation();

  return (
    <Modal
      open={isOpen}
      title={t('UpgradeSuccessModal.Title')}
      onClose={onClose}
    >
      <p>{t('UpgradeSuccessModal.Upgraded')}</p>
      <p>
        <Trans
          i18nKey="UpgradeSuccessModal.Issue"
          components={{
            linktag: <a href={t('Links.Support')} />,
          }}
        />
      </p>
      <div className={styles.buttons}>
        <Button onClick={onClose}>{t('UpgradeSuccessModal.Continue')}</Button>
      </div>
    </Modal>
  );
};
